import Character from "./Character";
import cloneDeep from "lodash/cloneDeep";

class Hero extends Character {
  constructor(v) {
    super(v);
    this.inventory = [];
  }

  addToInventory(item) {
    this.inventory.push(item);
  }
  
  equipFromInventory(invIndex) {
    if (this.inventory[invIndex].equipable) {
      let tempItem = cloneDeep(this.inventory[invIndex]); //copy from inventory
      this.inventory.splice(invIndex,1); // item now only in temp variable
      switch (tempItem.type) {
        case 'Main Hand':
          if (this.equipment.mainHand) {
            this.addToInventory(cloneDeep(this.equipment.mainHand));
            this.equipment.mainHand = null;
          }
          this.equipment.mainHand = tempItem;
          break; 
        case 'Off Hand':
          if (this.equipment.offHand) {
            this.addToInventory(cloneDeep(this.equipment.offHand));
            this.equipment.offHand = null;
          }
          if (this.equipment.mainHand) {
            if (this.equipment.mainHand.type === 'Two Hand') {
              this.addToInventory(cloneDeep(this.equipment.mainHand));
              this.equipment.mainHand = null;
            }
          }
          this.equipment.offHand = tempItem;
          break;
        case 'Two Hand':
          if (this.equipment.mainHand) {
            this.addToInventory(cloneDeep(this.equipment.mainHand));
            this.equipment.mainHand = null;
          }
          if (this.equipment.offHand) {
            this.addToInventory(cloneDeep(this.equipment.offHand));
            this.equipment.offHand = null;
          }
          this.equipment.mainHand = tempItem;
          break;
        case 'Head':
          if (this.equipment.head) {
            this.addToInventory(cloneDeep(this.equipment.head));
            this.equipment.head = null;
          }
          this.equipment.head = tempItem;
          break;
        case 'Arms':
          if (this.equipment.arms) {
            this.addToInventory(cloneDeep(this.equipment.arms));
            this.equipment.arms = null;
          }
          this.equipment.arms = tempItem;
          break;
        case 'Chest':
          if (this.equipment.chest) {
            this.addToInventory(cloneDeep(this.equipment.chest));
            this.equipment.chest = null;
          }
          this.equipment.chest = tempItem;
          break;
        case 'Feet':
          if (this.equipment.feet) {
            this.addToInventory(cloneDeep(this.equipment.feet));
            this.equipment.feet = null;
          }
          this.equipment.feet = tempItem;
          break;
        default:
          console.log("Something Broke...")
          break;
      }
    }
  }
}

export default Hero;
